import { render, staticRenderFns } from "./supplier-penalties.vue?vue&type=template&id=15da10df&scoped=true&"
import script from "./supplier-penalties.vue?vue&type=script&lang=js&"
export * from "./supplier-penalties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15da10df",
  null
  
)

export default component.exports